export function initFilesBlock() {
    const blocks = [].slice.call(document.querySelectorAll('[data-block="FilesBlock"]'));
    blocks.forEach(initFilesBlockInstance);
}

function initFilesBlockInstance(root) {
    const button = root.querySelector('.-load-more-btn');
    const blocksToShow = [].slice.call(root.querySelectorAll('.-col.inactive'));

    button.addEventListener('click', () => {
        blocksToShow.forEach((block) => {
            jQuery(button).fadeOut();
            jQuery(block).slideDown();
        });
    });
}
